import React, {
  createContext, useState, useMemo, 
 } from 'react';
 import PropTypes from 'prop-types';
 
 export const Mealcontext = createContext();
 
 const MealContextProvider = ({ children }) => {
   const [refresh, setRefresh] = useState(false);
   const [isDetailsClick, setIsDetailsClick] = useState(false);
   const [resaurantDetailsId, setRestaurantDetailsId] = useState();
   const [click, setclick] = useState('searchSelect');
   const [activeKey, setActiveKey] = useState('1');



   const value = useMemo(() => ({ 
      refresh, 
      setRefresh, 
      setIsDetailsClick,
      isDetailsClick,
      resaurantDetailsId,
      setRestaurantDetailsId,
      click, 
      setclick,
      activeKey, 
      setActiveKey,


   }), [refresh, isDetailsClick, resaurantDetailsId, click, activeKey]);
 
   return (
     <Mealcontext.Provider value={value}>
       {children}
     </Mealcontext.Provider>
   );
 };
 
 MealContextProvider.propTypes = {
   children: PropTypes.node.isRequired,
 };
 
 export default MealContextProvider;

